import { render, staticRenderFns } from "./CalendarNotePopup.vue?vue&type=template&id=64979ff0&scoped=true&"
import script from "./CalendarNotePopup.vue?vue&type=script&lang=js&"
export * from "./CalendarNotePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64979ff0",
  null
  
)

export default component.exports